module.exports = __webpack_public_path__ + "static/img/zhutuSDC200.8496c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-1/zhutuSDC200.png
// module id = ogIh
// module chunks = 0